import { memo } from 'react'
import { sanitizeHTML } from 'src/utils/sanitizeHTML'

import type { Review } from '../../../types/review'

interface SsrReviewsSnapshotProps {
  review: Review
}

function SsrReviewsSnapshot({ review }: SsrReviewsSnapshotProps) {
  const firstReviews = (review.reviews ?? []).slice(0, 3)

  if (firstReviews.length === 0) {
    return null
  }

  return (
    <ul
      aria-label="Primeiras avaliações do produto"
      data-testid="ssr-reviews-snapshot"
    >
      {firstReviews.map((reviewItem) => (
        <li key={reviewItem.id}>
          <p>{reviewItem.firstname}</p>
          <p>{reviewItem.note}/5</p>
          <div
            suppressHydrationWarning
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(reviewItem.body),
            }}
          />
        </li>
      ))}
    </ul>
  )
}

export default memo(SsrReviewsSnapshot)
